exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3KsGD{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;margin:10px 10px 6px}", ""]);

// exports
exports.locals = {
	"tooltipContainer": "_3KsGD"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/core/tooltip/tooltip-container.scss
// module id = 204
// module chunks = 0 1 2 3 4